import { useState } from 'react'

import { Link } from 'react-router-dom'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { authService } from 'services/auth.services'

import { useRenderLogger } from 'utils'

import InputField from 'components/form-inputs/input-field'
import Button from 'components/form-inputs/button'

import { Logo } from 'assets/images'
import SeoHead from 'components/meta-tags'

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)

  useRenderLogger('ForgotPassword')

  const validationSchema = Yup.object({
    email: Yup.string().label('Email').required()
  })

  const formik: any = useFormik({
    initialValues: { email: '' },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      authService.forgotPassword(values).then(() => {
        setLoading(false)
        formik.resetForm({
          values: {
            email: ''
          }
        })
      })
    }
  })

  return (
    <>
      <SeoHead seoTitle={'Forgot-Password'} />

      <div>
        {/* <div className="w-full bg-gradient-to-b bg-purple-900 text-white justify-center flex items-center p-2">
        <Link href="/">
          <Image src={Logo} alt="Logo" />
        </Link>
      </div> */}

        <div className="flex h-[calc(100vh)] w-full flex-col items-center justify-center overflow-y-auto">
          <Link
            to="/"
            className="flex w-full max-w-sm justify-center rounded-t-lg bg-purple-900 p-2"
          >
            <img src={Logo} alt="Logo" />
          </Link>
          <div className="w-full max-w-sm rounded-b-lg border border-gray-300 bg-white p-6 shadow-2xs">
            <h2 className="mb-1 text-center text-lg font-bold text-purple-900">Forgot Password</h2>
            <p className="mb-4 text-center text-base text-gray-900">
              Enter your email to receive a password reset link at your
            </p>

            <form onSubmit={formik.handleSubmit}>
              <InputField
                name="email"
                type="email"
                placeholder="Email"
                onChange={formik.handleChange}
                value={formik.values.email}
                required={true}
                onBlur={formik.handleBlur}
                error={!!(formik.touched.email && formik.errors.email)}
              />

              <Button
                label="Send"
                type="submit"
                className="mt-4 flex w-full justify-center rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950"
                loading={loading}
                disabled={!formik.isValid || !formik.dirty}
              />
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
export default ForgotPassword
